import { defineMessages } from 'react-intl';

const messages = defineMessages({
  minPasswordLength: `Lozinka mora imati najmanje 12 znakova.`,
  passwordRequired: 'Lozinka je obavezna.',
  passwordsDontMatch: 'Lozinke se ne podudaraju.',
  repeatPasswordRequired: 'Lozinke se ne podudaraju.',
});

export default messages;
